import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSText } from '@egds/react-core/text';
import { PackageType } from 'models/multi-item/multi-item-types';
import { SearchForm } from 'src/common/components/common/search-form';
import { useLocalization } from '@shared-ui/localization-context';
export const ChangeSearchForm = inject('searchResults', 'multiItem', 'context')(observer(({
  searchResults,
  multiItem,
  context,
  isHidden = false
}) => {
  var _a;
  const onUpdateResults = () => {
    if (searchResults) {
      searchResults.clearDefaultRequestFields();
      searchResults.clearPagination();
      searchResults.shouldFetch = true;
    }
  };
  const {
    formatText
  } = useLocalization();
  const packageType = (_a = multiItem === null || multiItem === void 0 ? void 0 : multiItem.getPackageType()) !== null && _a !== void 0 ? _a : undefined;
  const isMobile = context && context.deviceInformation && context.deviceInformation.mobile;
  const displayFields = React.useMemo(() => getDisplayFields(packageType), [packageType]);
  const ignoreFields = React.useMemo(() => ['startDate', 'endDate', 'partialStayStartDate', 'partialStayEndDate'], []);
  const searchFormProps = {
    model: searchResults && searchResults.searchCriteria,
    displayFields,
    ignoreFields,
    onUpdateResults,
    isMobile
  };
  return React.createElement(EGDSSpacing, {
    padding: {
      small: {
        inline: 'two'
      },
      medium: {
        inline: 'unset'
      }
    },
    margin: {
      block: 'two'
    },
    className: isHidden ? 'is-hidden' : ''
  }, React.createElement("div", {
    "data-stid": "section-hotel-search"
  }, (multiItem === null || multiItem === void 0 ? void 0 : multiItem.isTouchedCart) && !(multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath()) && React.createElement(EGDSSpacing, {
    margin: {
      blockend: 'two'
    }
  }, React.createElement(EGDSText, {
    size: 400,
    className: "pwa-theme--grey-700",
    weight: "bold"
  }, formatText('hotels.searchResults.multiProperty.searchCriteria.header'))), React.createElement("h2", {
    className: "is-visually-hidden"
  }, formatText('hotels.infosite.availabilityWizard.changeSearch.a11yLabel')), React.createElement(SearchForm, Object.assign({}, searchFormProps))));
}));
export const getDisplayFields = packageType => packageType && packageType !== PackageType.HC ? ['origin', 'destination', 'rooms', 'cabinClass', 'dateRange', 'directFlights', 'partialStayCheckbox', 'partialStayDateRange'] : ['destination', 'dateRange', 'rooms', 'pickUpTime', 'dropOffTime'];